<template>
  <div :style="cssVars">
    <page-layout :headerBackgroundColor="cssVars['--outcome-primary']">
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center">
          <span class="headerText text-white">
            {{
              selectedOutcome
                ? "This series of questions will customise your data table for "
                : "You need to select an outcome first"
            }}
          </span>
          <sustainability-dropdown
            :model="outcome"
            class="q-ml-sm"
            :style="`width: 230px;
                      background-color: rgba(0,0, 0, 0.3);
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            @input="selectOutcome"
            disable
          ></sustainability-dropdown>
        </div>
      </template>
      <template v-slot:content>
        <div class="column">
          <div class="col-auto" style="height: calc(100vh - 226px)">
            <div v-if="isCompleted" class="q-px-lg full-height">
              <div class="row text-center full-height items-center">
                <div class="col" style="max-width: 320px; margin: auto">
                  <span style="font-size: 1.5rem; font-weight: 700">
                    Questionnaire Completed for {{ selectedOutcome.label }}
                  </span>
                  <br />
                  <q-icon
                    name="mdi-check-circle-outline"
                    size="70px"
                    color="positive"
                  ></q-icon>
                  <br />
                  <q-btn
                    v-if="isCompleted"
                    class="q-px-sm q-py-xs bg-accent full-width q-mt-sm"
                    label="Continue"
                    text-color="white"
                    no-caps
                    flat
                    @click="goToDataUpload()"
                  >
                  </q-btn>
                </div>
              </div>
            </div>

            <div v-else-if="currentQuestion" class="q-px-lg q-mt-lg">
              <div class="row q-mt-md items-center">
                <span class="questionTitle">
                  {{ currentQuestion.question }}
                </span>
                {{ `(${currentQuestion.selectionType})` }}
                <span
                  class="text-negative text-bold"
                  style="font-size: 30px"
                  v-if="isError"
                >
                  *
                </span>
              </div>
              <div class="row">
                <div
                  class="col-12 col-md-6 q-pa-xs"
                  v-for="(option, i) in currentOptions"
                  :key="i"
                >
                  <q-card
                    :style="`background: ${
                      option.selected ||
                      (selectedQuestion && selectedQuestion.id === option.id)
                        ? cssVars['--outcome-secondary']
                        : '#eeeeee'
                    }; transition: background-color 200ms ease-in;color: ${
                      option.selected ||
                      (selectedQuestion && selectedQuestion.id === option.id)
                        ? 'white'
                        : 'black'
                    };`"
                    class="q-pa-sm full-width"
                    flat
                  >
                    <q-checkbox
                      @input="onBoxCheck(option)"
                      v-model="option.selected"
                      class="q-mr-sm"
                    >
                    </q-checkbox>
                    <span class="questionText"> {{ option.text }}</span>
                    <q-icon
                      v-if="option.whatsThat"
                      name="mdi-help-circle"
                      class="q-ml-xs cursor-pointer"
                      size="sm"
                      @click="
                        selectedQuestion =
                          selectedQuestion && selectedQuestion.id == option.id
                            ? null
                            : option
                      "
                    ></q-icon>
                  </q-card>
                </div>
              </div>
            </div>
          </div>
          <div class="col q-px-md">
            <q-btn
              v-if="currentQuestionIndex != 0"
              class="q-px-sm q-py-xs bg-secondary"
              label="Back to Previous Question"
              text-color="white"
              no-caps
              flat
              @click="previousQuestion"
            >
            </q-btn>
            <q-btn
              v-else
              class="q-px-sm q-py-xs bg-secondary"
              label="Back to Assessment Tool Selection"
              text-color="white"
              no-caps
              flat
              @click="goToAssessmentToolSelection"
            >
            </q-btn>

            <q-btn
              v-if="!isCompleted"
              class="q-px-sm q-py-xs bg-accent float-right"
              label="Next"
              text-color="white"
              no-caps
              flat
              @click="proceed"
            >
            </q-btn>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <!-- Wrapping only one DOM element, defined by QBtn -->
        <div class="column full-height full-width sidebar">
          <div class="col q-my-md q-pa-md">
            <h3>What's that?</h3>
          </div>
          <div class="col-auto q-px-md">
            <div style="height: calc(100vh - 180px)">
              <div
                v-if="selectedQuestion"
                v-html="selectedQuestion.whatsThat"
              ></div>
              <div v-else>
                Click on any question icon in the answers to reveal insights in
                to this selection.
              </div>
            </div>
          </div>
        </div>
      </template>
    </page-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
export default {
  components: {
    PageLayout,
    SustainabilityDropdown,
  },
  async mounted() {
    this.$store.dispatch("businessAnswers/loadAll").then(() => {
      if (this.selectedOutcome) {
        this.initSelectedOutcome();
      }
    });
  },
  data: () => ({
    outcome: null,
    selectedAnswers: [],
    currentAnswerMultiple: [],
    currentAnswerSingle: null,
    currentQuestion: null,
    currentQuestionIndex: null,
    currentOptions: [],
    isError: false,
    isCompleted: false,
    selectedQuestion: null,
  }),
  watch: {
    selectedOutcome: function () {
      this.initSelectedOutcome();
    },
    $route: {
      handler() {
        this.handleRoute();
      },
      props: true,
    },
  },
  computed: {
    ...mapGetters({
      outcomesList: "outcomes/list",
      currentUserData: "auth/currentUserData",
      questionList: "outcomePlanQuestionnaire/list",
      answersList: "businessAnswers/list",
      selectedOutcome: "businessOutcomePlans/selectedOutcome",
    }),
    cssVars() {
      let primaryColorFaded = this.selectedOutcome
        ? this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor.split("#")
          : ["", "162c47"]
        : "#162c47";
      let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
      if (this.selectedOutcome) {
        return {
          "--outcome-primary": this.selectedOutcome.primaryColor
            ? this.selectedOutcome.primaryColor
            : "#162c47",
          "--outcome-secondary": this.selectedOutcome.secondaryColor
            ? this.selectedOutcome.secondaryColor
            : "#162c47",
          "--outcome-tertiary": this.selectedOutcome.tertiaryColor
            ? this.selectedOutcome.tertiaryColor
            : "#162c47",
          "--outcome-primary-faded": primaryColorFadedString,
        };
      } else {
        return {
          "--outcome-primary": "#162c47",
          "--outcome-secondary": "#162c47",
          "--outcome-tertiary": "#162c47",
          "--outcome-primary-faded": "#162c47",
        };
      }
    },
  },
  methods: {
    backToDashboard() {
      // this.$router.push("/workspaceDashboard");
    },
    async handleRoute(firstRun = false) {
      if (this.$route.path.includes("completed")) {
        // If Plan is Completed
        this.isCompleted = true;
      } else if (
        this.$route.params.hasOwnProperty("outcomePlanQuestionnaire_id")
      ) {
        // If outcome plan questionnaire is selected
        this.getCurrentQuestion(!firstRun);
      } else if (this.$route.params.hasOwnProperty("outcomesID")) {
        // Init Outcome Questionnaire Loads outcome and then Loads First question
        this.initFirstQuestion();
      }
    },
    initSelectedOutcome() {
      this.outcome = this.selectedOutcome;
      this.handleRoute(true);
    },
    initOptions() {
      if (this.currentQuestion.options.length > 0) {
        this.currentOptions = this.currentQuestion.options.map((e) => ({
          ...e,
          selected: this.answersList.find(
            (v) => e.id == v.outcomePlanQuestionnaireOptions_id
          )?.value
            ? true
            : false,
        }));
      } else {
        this.currentOptions = [];
      }
      if (this.currentQuestion.hasNoneField === 1) {
        this.currentOptions.push({
          text: "None of the above",
          selected: false,
          isExclusive: true,
        });
      }
    },
    checkIfQuestionAlreadyAnswered() {
      if (this.currentQuestion.options.length > 0) {
        let answeredOptionIdList = this.answersList.map(
          (e) => e.outcomePlanQuestionnaireOptions_id
        );
        let optionsId = this.currentQuestion.options.map((e) => e.id);
        let answeredOptions = [];
        let isAlreadyAnswered = false;
        for (let i = 0; i < optionsId.length; i++) {
          if (answeredOptionIdList[i] == optionsId[i]) {
            answeredOptions.push(this.currentQuestion.options[i]);
          }
          if (isAlreadyAnswered == false) {
            answeredOptionIdList.forEach((e) => {
              if (e == optionsId[i]) {
                isAlreadyAnswered = true;
              }
            });
          }
        }

        return {
          isAnswered: isAlreadyAnswered,
          answeredOptions: answeredOptions,
        };
      } else {
        return {
          isAnswered: false,
          answeredOptions: [],
        };
      }
    },
    async initFirstQuestion() {
      this.currentQuestion = null;
      await this.loadOutcomePlanQuestions();
      if (this.questionList.length > 0) {
        this.currentQuestion = this.questionList[0];
        this.currentQuestionIndex = 0;
        this.initOptions();
        let path = this.$route.path + "/question/" + this.currentQuestion.id;
        if (this.$route.path != path) {
          this.$router.push(path);
        }
      }
    },
    async loadOutcomePlanQuestions() {
      if (
        !this.questionList ||
        !this.questionList[0] ||
        this.questionList[0].outcomes_id != this.selectedOutcome.id
      ) {
        await this.$store.dispatch(
          "outcomePlanQuestionnaire/loadAllByOutcomesIDWithOptions",
          this.selectedOutcome.id
        );
      }
    },
    proceed() {
      let optionsSelected = this.currentOptions.filter((q) => q.selected);

      if (optionsSelected.length == 0) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "Please select an answer",
        });
        this.isError = true;
        return false;
      }
      this.selectedQuestion = null;

      this.nextQuestion();
      this.isError = false;
    },
    previousQuestion() {
      this.$router.push(
        `${this.$route.path.split("question")[0]}question/${
          this.questionList[this.currentQuestionIndex - 1].id
        }`
      );
      this.isCompleted = false;

      // this.getCurrentQuestion(this.questionList[this.currentQuestionIndex]);
    },
    async getCurrentQuestion(customID = null) {
      await this.loadOutcomePlanQuestions();

      if (this.questionList.length > 0) {
        let questionIndex = this.questionList.findIndex(
          (e) => e.id == this.$route.params.outcomePlanQuestionnaire_id
        );

        if (questionIndex >= 0) {
          this.currentQuestionIndex = questionIndex;
          this.currentQuestion = this.questionList[questionIndex];
          if (this.checkIfQuestionAlreadyAnswered().isAnswered && !customID) {
            this.nextQuestion(true);
          }
          this.initOptions();
        }
      }
    },
    nextQuestion(isAnswered = false) {
      if (this.currentQuestionIndex != null) {
        if (
          !isAnswered &&
          ((this.currentQuestion.selectionType == "Single" &&
            this.currentAnswerSingle != null) ||
            (this.currentQuestion.selectionType != "Single" &&
              this.currentAnswerMultiple.length > 0))
        ) {
          this.addAnswerToDatabase();
          // This will run the option action, e.g. Star sources, or categories etc.
          this.initialiseOptionAction(
            this.currentQuestion,
            this.currentAnswerSingle,
            this.currentAnswerMultiple
          );
        }
        this.clearAnswers();
        this.currentQuestionIndex += 1;

        // Handle Question Route
        this.handleQuestionRoute();
        this.initOptions();
      }
    },
    handleQuestionRoute() {
      if (this.currentQuestionIndex <= this.questionList.length - 1) {
        this.currentQuestion = this.questionList[this.currentQuestionIndex];
        let path = `${this.$route.path.split("/question")[0]}/question/${
          this.currentQuestion.id
        }`;
        this.$router.push(path);
      } else {
        //questionnaire completed
        this.$router.push(
          `${this.$route.path.split("/question")[0]}/question/completed`
        );
      }
    },
    clearAnswers() {
      this.currentAnswerSingle = null;
      this.currentAnswerMultiple.splice(0);
    },
    addAnswerToDatabase() {
      if (this.currentAnswerSingle) {
        let answerPayload = {
          value: 1,
          outcomePlanQuestionnaire: this.currentQuestion.id,
          outcomePlanQuestionnaireOptions_id: this.currentAnswerSingle.id,
        };
        this.$store.dispatch("businessAnswers/new", answerPayload);
      }
      if (this.currentAnswerMultiple && this.currentAnswerMultiple.length > 0) {
        let multiAnswerPayload = [];
        this.currentAnswerMultiple.forEach((e) => {
          if (e.isExclusive) {
            multiAnswerPayload.push({
              isNone: 1,
              outcomePlanQuestionnaire: this.currentQuestion.id,
              outcomePlanQuestionnaireOptions_id: null,
            });
          } else {
            multiAnswerPayload.push({
              value: 1,
              outcomePlanQuestionnaire: this.currentQuestion.id,
              outcomePlanQuestionnaireOptions_id: e.id,
            });
          }
        });
        this.$store.dispatch(
          "businessAnswers/saveMultipleAnswers",
          multiAnswerPayload
        );
      }
    },
    onBoxCheck(option) {
      if (this.currentQuestion.selectionType === "Single") {
        this.currentAnswerSingle = option;
      } else if (this.currentQuestion.selectionType === "Multiple") {
        this.currentAnswerSingle = null;
        let existingAnswerIndex = this.currentAnswerMultiple.findIndex((e) => e.id === option.id || (e.text === "None" && e.text === option.text));
        let wasAlreadySelected = existingAnswerIndex > -1;

        if (!wasAlreadySelected) {
          // Answer was clicked and was not already selected, so the selection should be added
          // If the option is exclusive, remove all other selected options
          if (option.isExclusive) {
            this.currentAnswerMultiple.splice(0);
            this.currentAnswerMultiple.push(option);
          }
          // If the option is not exclusive, add it to the selection and remove any selections that are exclusive
          else {
            let exclusiveIndex = this.currentAnswerMultiple.findIndex(opt => opt.isExclusive);
            if(exclusiveIndex > -1) this.currentAnswerMultiple.splice(exclusiveIndex, 1);
            this.currentAnswerMultiple.push(option);
          }
        } else {
          // Answer was clicked, and was already selected, so remove it from the selection
          this.currentAnswerMultiple.splice(existingAnswerIndex, 1);
        }
      }
      this.refreshOptions();
    },
    refreshOptions() {
      for (const option of this.currentOptions) {
        if (this.currentAnswerMultiple.includes(option) || this.currentAnswerSingle === option) {
          option.selected = true;
        } else {
          option.selected = false;
        }
      }
    },
    selectOutcome(outcome) {
      // this.$router.push("/outcomePlanQuestionnaire/outcome/" + outcome.id);
    },
    initialiseOptionAction(currentQuestion, singleOption, multipleOptions) {
      let payload = JSON.parse(JSON.stringify(currentQuestion));
      if (singleOption) {
        payload.selectedOptions = [{ ...singleOption }];
      } else if (multipleOptions && multipleOptions.length > 0) {
        payload.selectedOptions = multipleOptions;
      }
      if (payload.selectedOptions.length > 0) {
        this.$store.dispatch(
          "businessStarSources/starByQuestionOption",
          payload
        );
      }
    },

    async goToDataUpload() {
      await this.$store.dispatch("businessOutcomePlans/markQuestionnaireFinished", {
        id: this.selectedOutcome.id,
        business_id: this.currentUserData.sustainabilityBusiness_id
      });

      await this.$router.push(
        `${
          this.$route.path.split("outcomePlanQuestionnaire")[0]
        }dataUpload/year/${this.$moment().format("YYYY")}`
      );
    },
    goToAssessmentToolSelection() {
      this.$router.push(
        `${
          this.$route.path.split("outcomePlanQuestionnaire")[0]
        }chooseAssessmentTool`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }

  h4 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }
}

.headerText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}

.questionTitle {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 1.3rem;
  margin: 10px 0px;
}

.questionText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 1.1rem;
  margin: 10px 0px;
}

.button-bg {
  background-color: var(--outcome-secondary);
}

.button-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 11.6054px;
}
</style>
